//* Importing Hooks from React
import { useState, useCallback } from "react";

//! Importing API
import { importHistoryCollaboratorAPI } from "../../../hooks/importHistory/importHistoryCollaboratorAPI";

//? Importing types
import { ImportHistoryCollaborator } from "../../../hooks/importHistory/types/typesCollaborator";
interface ImportStatus extends ImportHistoryCollaborator {}
export function useImportHistory(token: string) {
  const [importHistory, setImportHistory] = useState<ImportStatus[]>([]);
  const [isFetchingHistory, setIsFetchingHistory] = useState<boolean>(false);
  const fetchImportHistory = useCallback(async () => {
    setIsFetchingHistory(true);
    try {
      const response = await importHistoryCollaboratorAPI.getAll("", 1, token, 100);
      setImportHistory(response.import_histories);
    } catch (error) {
      console.error("Erro ao buscar históricos de importação:", error);
    } finally {
      setIsFetchingHistory(false);
    }
  }, [token]);
  return {
    importHistory,
    isFetchingHistory,
    fetchImportHistory,
    setImportHistory,
  };
}
